import AssessmentDetailsPage from "../components/competencyAssessment/details";

const AssessmentDetails = () => {
  return <AssessmentDetailsPage />;
};

export default AssessmentDetails;
